/*###########################################################################
// Header
//#########################################################################*/

import { throttle } from '../utilities/_throttleDebounce'

const header = {
	config: {
		main: 'main',
		header: '.header',
		headerBackdrop: '.header__backdrop',
		headerNav: '.header__nav',
		headerMenuBtn: '.header__menu-btn',
		headerSubMenu: '.header__submenu',
		headerSubMenuSingle: '.header__submenu--single',
		headerSubMenuTrigger: '.header__nav__item--sub',
		headerSubMenuBack: '.header__submenu__back'
	},

	elements: {
		main: null,
		header: null,
		headerBackdrop: null,
		headerNav: null,
		headerMenuBtn: null,
		headerSubMenus: null,
		headerSubMenuSingles: null,
		headerSubMenuTriggers: null
	},

	state: {
		isMobile: false,
		headerHeight: 0,
	},

  breakpoint: 1280,

	init() {
		this.elements.header = document.querySelector(this.config.header)

		if (this.elements.header !== null) {
			this.state.headerHeight = this.elements.header.clientHeight

			// Get elements
			//
			this.elements.main = document.querySelector(this.config.main)
			this.elements.headerBackdrop = this.elements.header.querySelector(this.config.headerBackdrop)
			this.elements.headerNav = this.elements.header.querySelector(this.config.headerNav)
			this.elements.headerMenuBtn = this.elements.header.querySelector(this.config.headerMenuBtn)
			this.elements.headerSubMenus = this.elements.header.querySelectorAll(this.config.headerSubMenu)
			this.elements.headerSubMenuSingles = this.elements.header.querySelectorAll(this.config.headerSubMenuSingle)
			this.elements.headerSubMenuTriggers = this.elements.header.querySelectorAll(this.config.headerSubMenuTrigger)

			// Handle scroll
			//
			this.handleScroll()

			// Handle backdrop
			//
			this.handleBackdropClick()

			// Handle menu btn
			//
			this.handleMenuBtn()

			// Handle menu items
			//
			this.handleMenuItems()

			// Handle sub menu singles
			//
			this.handleSubMenuSingles()

			// Set nav height
			//
			if (window.innerWidth < this.breakpoint) {
				this.setNavHeight()

				this.state.isMobile = true
			} else {
				this.state.isMobile = false
			}

			window.addEventListener('resize', throttle(() => {
				this.state.headerHeight = this.elements.header.clientHeight

				if (window.innerWidth < this.breakpoint) {
					this.setNavHeight()

					this.state.isMobile = true
				} else {
					this.unsetNavHeight()

					if (this.state.isMobile === true) {
						this.resetMenuState()
					}

					this.state.isMobile = false
				}

				this.handleSubMenuSingles()
			}, 250))

			// Handle page change
			//
			window.addEventListener('before-page-change', () => {
				this.resetMenuState()
			})
		}
	},

	handleScroll() {
		let sectionNavigator = document.querySelector('.sectionNavigator')
		let sectionNavigatorTop = 0
		if (sectionNavigator !== null) {
			sectionNavigatorTop = sectionNavigator.parentNode.offsetTop
		}
		window.addEventListener('page-change', () => {
			// Reset local values if section nav exists
			//
			setTimeout(function() {
				sectionNavigator = document.querySelector('.sectionNavigator')
				if (sectionNavigator !== null) {
					sectionNavigatorTop = sectionNavigator.parentNode.offsetTop
				}
			}, 250)
		})

		let scrollPosition = window.pageYOffset || document.documentElement.scrollTop

		// Initial check
		//
		if (scrollPosition > this.state.headerHeight) {
			this.elements.main.classList.add('header--scrolled')
			this.elements.header.classList.add('header--scrolled')
		} else {
			this.elements.main.classList.remove('header--scrolled')
			this.elements.header.classList.remove('header--scrolled')
		}

		setTimeout(() => {
			// Set nav height
			//
			if (window.innerWidth < this.breakpoint) {
				this.setNavHeight()
			}
		}, 1000)

		let lastScrollTop = 0

		window.addEventListener('scroll', throttle(() => {
			scrollPosition = window.scrollY || document.documentElement.scrollTop

			if (sectionNavigator !== null) {
				// Ensure switching between pages with/without section navs works properly
				//
				if (this.elements.header.classList.contains('header--scrolling-up')) {
					this.elements.header.classList.remove('header--scrolling-up')
				}

				if (scrollPosition > (sectionNavigatorTop - this.elements.header.getBoundingClientRect().height * 2)) {
					this.elements.main.classList.add('header--scrolled')
					this.elements.header.classList.add('header--scrolled')
				} else {
					this.elements.main.classList.remove('header--scrolled')
					this.elements.header.classList.remove('header--scrolled')
				}
			} else {
				if (scrollPosition > this.state.headerHeight) {
					this.elements.main.classList.add('header--scrolled')
					this.elements.header.classList.add('header--scrolled')
				} else {
					this.elements.main.classList.remove('header--scrolled')
					this.elements.header.classList.remove('header--scrolled')
				}

				if (lastScrollTop > scrollPosition) {
					this.elements.header.classList.add('header--scrolling-up')
				} else {
					this.elements.header.classList.remove('header--scrolling-up')
				}
				lastScrollTop = scrollPosition <= 0 ? 0 : scrollPosition
			}

			setTimeout(() => {
				// Set nav height
				//
				if (window.innerWidth < this.breakpoint) {
					this.setNavHeight()
				}
			}, 500)
		}, 250))
	},

	setNavHeight() {
		if (this.elements.headerNav !== null) {
			this.elements.headerNav.style.height = (window.innerHeight - (this.elements.header.clientHeight - 5)) + "px"

			for (let i = 0; i < this.elements.headerSubMenus.length; i++) {
				const headerSubMenu = this.elements.headerSubMenus[i]

				headerSubMenu.style.height = (window.innerHeight - (this.elements.header.clientHeight - 12)) + "px"
			}
		}
	},

	unsetNavHeight() {
		if (this.elements.headerNav !== null) {
			this.elements.headerNav.style.height = ""

			for (let i = 0; i < this.elements.headerSubMenus.length; i++) {
				const headerSubMenu = this.elements.headerSubMenus[i]

				headerSubMenu.style.height = ""
			}
		}
	},

	handleMenuBtn() {
		if (this.elements.headerMenuBtn !== null) {
			this.elements.headerMenuBtn.addEventListener('click', (e) => {
				e.preventDefault()

				if (this.elements.header.classList.contains('header--open')) {
					this.elements.header.classList.remove('header--open')
					window.app.enableScroll()

					// Reset sub menus
					//
					setTimeout(() => {
						for (let i = 0; i < this.elements.headerSubMenuTriggers.length; i++) {
							const headerSubMenuTrigger = this.elements.headerSubMenuTriggers[i]
							const headerSubMenu = headerSubMenuTrigger.nextElementSibling
							headerSubMenu.classList.remove('header__submenu--open')
							headerSubMenu.scrollTop = 0
						}

						// Remove potential classes
						//
						this.elements.header.classList.remove('header--sub-open')
						this.elements.headerNav.classList.remove('overflow-hidden')

						// Reset nav scroll
						//
						this.elements.headerNav.scrollTop = 0

						// Reset nav overflow
						//
						this.elements.headerNav.style.overflowY = ''
					}, 500)
				} else {
					this.elements.header.classList.add('header--open')
					window.app.disableScroll()
				}
			})
		}
	},

	resetMenuState() {
		this.elements.header.classList.remove('header--open')
		window.app.enableScroll()

		// Reset sub menus
		//
		setTimeout(() => {
			for (let i = 0; i < this.elements.headerSubMenuTriggers.length; i++) {
				const headerSubMenuTrigger = this.elements.headerSubMenuTriggers[i]
				const headerSubMenu = headerSubMenuTrigger.nextElementSibling
				headerSubMenu.classList.remove('header__submenu--open')
				headerSubMenu.scrollTop = 0
				this.setSubMenuTabIndexes(headerSubMenu, false)
			}

			// Remove potential classes
			//
			this.elements.header.classList.remove('header--sub-open')
			this.elements.headerNav.classList.remove('overflow-hidden')

			// Reset nav scroll
			//
			this.elements.headerNav.scrollTop = 0

			// Reset dropdowns
			//
			if (this.elements.headerNav.querySelector('.header__nav__item--active') !== null) {
				this.elements.headerNav.querySelector('.header__nav__item--active').classList.remove('header__nav__item--active')
			}
			this.elements.headerBackdrop.classList.remove('header__backdrop--active')

			// Reset nav overflow
			this.elements.headerNav.style.overflowY = ''
		}, 500)
	},

	handleMenuItems() {
		for (let k = 0; k < this.elements.headerSubMenuTriggers.length; k++) {
			const headerSubMenuTrigger = this.elements.headerSubMenuTriggers[k]

			if (headerSubMenuTrigger.nextElementSibling !== null) {
				const headerSubMenu = headerSubMenuTrigger.nextElementSibling
				const headerSubMenuBack = headerSubMenu.querySelector(this.config.headerSubMenuBack)

				headerSubMenuTrigger.addEventListener('keyup', function (e) {
					if (e.key === 'Enter' || e.keyCode === 13) {
						headerSubMenuTrigger.click()
					}
				})

				headerSubMenuTrigger.addEventListener('click', () => {
					// Handle mobile and desktop states
					//
					if (window.innerWidth < this.breakpoint) {
						if (!headerSubMenu.classList.contains('header__submenu--open')) {
							headerSubMenu.classList.add('header__submenu--open')
							this.elements.header.classList.add('header--sub-open')
							this.elements.headerNav.classList.add('overflow-hidden')
							this.elements.headerNav.scrollTop = 0
							headerSubMenu.scrollTop = 0

							setTimeout(() => {
								this.elements.headerNav.style.overflowY = 'hidden'
							}, 500)
						}
					} else {
						// Remove current active dropdown
						//
						if (headerSubMenuTrigger !== this.elements.headerNav.querySelector('.header__nav__item--active')) {
							if (this.elements.headerNav.querySelector('.header__nav__item--active') !== null) {
								this.elements.headerNav.querySelector('.header__nav__item--active').classList.remove('header__nav__item--active')
								this.elements.headerBackdrop.classList.remove('header__backdrop--active')
								this.setSubMenuTabIndexes(headerSubMenu, false)
							}
						}

						// Toggle active dropdown
						//
						if (headerSubMenuTrigger.classList.contains('header__nav__item--active')) {
							this.elements.header.classList.remove('header--sub-open')
							headerSubMenuTrigger.classList.remove('header__nav__item--active')
							this.elements.headerBackdrop.classList.remove('header__backdrop--active')
							window.app.enableScroll()
							this.setSubMenuTabIndexes(headerSubMenu, false)
						} else {
							this.elements.header.classList.add('header--sub-open')
							headerSubMenuTrigger.classList.add('header__nav__item--active')
							this.elements.headerBackdrop.classList.add('header__backdrop--active')
							window.app.disableScroll()

							// On opening a dropdown, ensure all submenu tab indexes are reset
							//
							for (let h = 0; h < this.elements.headerSubMenuTriggers.length; h++) {
								const headerSubMenuTrigger = this.elements.headerSubMenuTriggers[h]

								if (headerSubMenuTrigger.nextElementSibling !== null) {
									const headerSubMenu = headerSubMenuTrigger.nextElementSibling

									this.setSubMenuTabIndexes(headerSubMenu, false)
								}
							}

							// Set tab indexes
							//
							this.setSubMenuTabIndexes(headerSubMenu, true)
						}
					}
				})

				if (headerSubMenuBack !== null) {
					headerSubMenuBack.addEventListener('click', () => {
						if (window.innerWidth < this.breakpoint) {
							if (headerSubMenu.classList.contains('header__submenu--open')) {
								headerSubMenu.classList.remove('header__submenu--open')
								this.elements.header.classList.remove('header--sub-open')
								this.elements.headerNav.classList.remove('overflow-hidden')
								this.elements.headerNav.scrollTop = 0
								headerSubMenu.scrollTop = 0

								setTimeout(() => {
									this.elements.headerNav.style.overflowY = ''
								}, 500)
							}
						}
					})
				}
			}
		}
	},

	handleSubMenuSingles() {
		if (this.elements.headerSubMenuSingles !== null && window.innerWidth >= this.breakpoint) {
			for (let i = 0; i < this.elements.headerSubMenuSingles.length; i++) {
				const headerSubMenuSingle = this.elements.headerSubMenuSingles[i]
				const parentNavItem = headerSubMenuSingle.previousElementSibling
				const leftPosition = parentNavItem.getBoundingClientRect().left + (parentNavItem.getBoundingClientRect().width / 2)

				headerSubMenuSingle.style.left = leftPosition + 'px'
			}
		} else {
			for (let i = 0; i < this.elements.headerSubMenuSingles.length; i++) {
				const headerSubMenuSingle = this.elements.headerSubMenuSingles[i]
				headerSubMenuSingle.style.left = ''
			}
		}
	},

	setSubMenuTabIndexes(headerSubMenu, isFocusable) {
		const focusableElements = headerSubMenu.querySelectorAll('a, button')

		for (let i = 0; i < focusableElements.length; i++) {
			const focusableElement = focusableElements[i]

			if (isFocusable === true) {
				focusableElement.tabIndex = '0'
			} else {
				focusableElement.tabIndex = '-1'
			}
		}
	},

	handleBackdropClick() {
		this.elements.headerBackdrop.addEventListener('click', () => {
			if (this.elements.headerNav.querySelector('.header__nav__item--active') !== null && window.innerWidth > this.breakpoint) {
				this.elements.header.classList.remove('header--sub-open')
				this.elements.headerNav.querySelector('.header__nav__item--active').classList.remove('header__nav__item--active')
				this.elements.headerBackdrop.classList.remove('header__backdrop--active')
				window.app.enableScroll()
			}
		})
	}
}

initComponent(() => {
	header.init()
}, true)
